class PlayerSettings{
    constructor() {
        this._settings = {
            "videoId": "",
            "title": "",
            "ccFileRoot": "",
            "duration": 0,
            "autoplay": false,
            "source": "",
            "startTime": 0,
            "poster": "",
            "ccInfo": {},
            "controls": Object.assign({}, {
                "enabled": true
            }),
            "plugins": {},
            "resources": []
        }
    }
    get customSource() {
        return this._settings.customSource;
    }
    set customSource(flag = undefined) {
        this._settings.customSource = flag;
    }
    get autoplay() {
        return this._settings.autoplay;
    }
    set autoplay(flag = false) {
        this._settings.autoplay = flag;
    }
    get ccFileRoot() {
        return this._settings.ccFileRoot;
    }
    set ccFileRoot(val = "") {
        this._settings.ccFileRoot = val;
    }
    get controls() {
        return this._settings.controls;
    }
    get duration() {
        return this._settings.duration;
    }
    set duration(val = 0) {
        this._settings.duration = val;
    }
    get plugins() {
        return this._settings.plugins;
    }
    set plugins(plugins = {}) {
        this._settings.plugins = plugins;
    }
    get resources() {
        return this._settings.resources;
    }
    set resources(resources = []) {
        this._settings.resources = resources;
    }
    get source() {
        return this._settings.source;
    }
    set source(val = "") {
        this._settings.source = val;
    }
    get startTime(){
        return this._settings.startTime;
    }
    set startTime( val = 0){
        this._settings.startTime = val;
    }
    get title() {
        return this._settings.title;
    }
    set title(val = "") {
        this._settings.title = val;
    }
    get videoId() {
        return this._settings.videoId;
    }
    set videoId(id = "") {
        this._settings.videoId = id;
    }

}
export { PlayerSettings }
